/**
 * NoNotebookSelected (Intelligence Studio)
 *
 * Extracted from containers/IntelligenceStudioPage.jsx to keep the container SRP-clean.
 */

import React from 'react';

import { Layers } from 'lucide-react';

const NoNotebookSelected = () => (
  <div className="flex-1 flex items-center justify-center text-slate-400">
    <div className="text-center">
      <Layers className="h-16 w-16 mx-auto mb-4 opacity-20" />
      <p className="text-lg font-medium text-slate-600 dark:text-neutral-300">Select a notebook</p>
      <p className="text-sm">or create a new one to get started</p>
    </div>
  </div>
);

export default NoNotebookSelected;
